<!--
 * @Description: In User Settings Edit
 * @Author: laikt
 * @LastEditors: laikt
 * @Date: 2019-03-20 09:51:04
 * @LastEditTime: 2019-03-22 09:59:08
 -->
<template>
    <div class="breadcrumb">
        <ul>
            <template v-for="(item,index) in breadcrumbList">
                <li @click="handleSelect(item)"
                    :class="index!==breadcrumbList.length-1?'is-hover':''">
                    {{item.name}}
                </li>
                <i class="el-icon-arrow-right"
                   v-if="index!==breadcrumbList.length-1"></i>
            </template>

        </ul>
    </div>
    <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item v-for="item in breadcrumbList"
                            :key="item.id"
                            :to={path:item.demoFlag}
                            @click="handleSelect.prevent(item)">{{item.name}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{position}}</el-breadcrumb-item>
    </el-breadcrumb> -->
</template>

<script>
import { mapGetters } from "vuex";
export default {
    name: "",
    data() {
        return {
            position: ""
        };
    },

    computed: {
        ...mapGetters(["breadcrumbList"])
    },
    mounted() {
        console.log(this.breadcrumbList);
    },
    methods: {
        handleSelect(item) {
            debugger;
            console.log(this.breadcrumbList);
            if (typeof item === "undefined") {
                this.$router.push("/");
            } else {
                if (item.name == "首页") {
                    this.$router.push("/");
                    return;
                }
                if (item.opennew !== "1") {
                    let idflag = item.id;
                    //增加跳转别菜单的判断
                    if (item.urlMenu == "4") {
                        window.open(item.demoFlag, "_self");
                    }
                    if (item.urlMenu === "3") {
                        let array = item.parentIds.split(",");
                        idflag = array[array.length - 1];
                    }
                    // this.$store.dispatch("ParentList", "");
                    if (item.name == "首页") {
                        this.$router.push({
                            path: item.demoFlag
                        });
                    } else {
                        this.$router.push({
                            path: item.demoFlag,
                            query: {
                                id: idflag
                            }
                        });
                    }
                } else {
                    this.$store.dispatch("UpdateActive", item);
                }
            }
            // alert();
            // this.activeIndex = item.id;
            // console.log(item);
        }
    }
};
</script>
<style lang="scss" scoped>
.breadcrumb {
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    ul {
        overflow: hidden;
        li {
            list-style: none;
            display: inline-block;
            cursor: pointer;
            color: #c0c4cc;
        }
        .is-hover {
            font-weight: bold;
            color: #ffffff;
        }
        .is-hover:hover {
            color: #fabe00;
        }
        .el-icon-arrow-right {
            color: #c0c4cc;
            margin: 0 6px;
        }
    }
}
</style>
